import{useState as o,useEffect as r}from"react";import{isTouchDevice as c}from"@danfoss/mosaic-core";const t=()=>{const[t,e]=o(!1);return r((()=>{e(c())}),[]),{isTouchingDevice:t}};export{t as useIsTouchingDevice};
